import { ChangeDetectorRef, Directive, inject, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '../../../services/responsive/responsive.service';

@Directive({
  selector: '[appNgIfWeb]',
  standalone: true,
})
export class NgIfWebDirective implements OnInit, OnDestroy {
  private readonly responsiveService = inject(ResponsiveService);
  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private subscription!: Subscription;

  ngOnInit(): void {
    this.subscription = this.responsiveService.isMobileOrTablet$.subscribe((isMobileOrTablet) => {
      if (isMobileOrTablet) {
        this.viewContainer.clear();
      } else {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
